/* eslint-disable no-func-assign */
import { FC } from "react";
import styles from "./ItemsList.module.css";
import Card from "../Card/Card";
import useWindowSize from "../../hooks/useWindowSize";
import { cardWidth } from "../../utils/layoutUtils";

interface Props {
  items: Array<any>;
  onShowModal: () => void;
  emptyString: string;
}
const ItemsList: FC<Props> = ({ items, onShowModal, emptyString }) => {
  const windowSize = useWindowSize();
  const width = cardWidth(windowSize.width);
  return (
    <div className={styles.listCards}>
      {items.length ? (
        items.map((item) => {
          return (
            <Card
              key={item.id}
              onShowModal={onShowModal}
              onClick={() => {
                if (item.itemShoppingURL) {
                  window.open(item.itemShoppingURL);
                } else {
                  onShowModal();
                }
              }}
              itemPhotoURL={item.thumbnailImageURL}
              brandName={item.brand}
              itemShoppingUrl={item.itemShoppingURL ?? ""}
              width={width}
            />
          );
        })
      ) : (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            alignSelf: "center",
            justifySelf: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {emptyString}
        </div>
      )}
    </div>
  );
};
export default ItemsList;
